module.exports = __webpack_public_path__ + "img/New-message-pana.3fe4903a.png";